/**
 * Session Context - Authentication State Container
 *
 * This context is defined in the entities layer and provided by
 * the AuthProvider in the app layer. This maintains FSD compliance
 * by allowing all layers to access auth state without violating
 * the import hierarchy.
 */

import { createContext } from 'react';
import type { SessionContextValue } from './types';

/**
 * Auth/Session context
 *
 * Provides authentication state and actions to the application.
 * Must be used within an AuthProvider from @app/providers.
 *
 * @example
 * ```tsx
 * const { user, signIn, signOut } = useSession();
 * ```
 */
export const SessionContext = createContext<SessionContextValue | null>(null);
